import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=27ce6435&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import "./ForgotPasswordModal.vue?vue&type=style&index=0&id=27ce6435&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ce6435"]])

export default __exports__